"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/MetaMessageRow.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _requests = require('shared/selectors/requests');
var _hooks = require('web/services/hooks');
var _MetaMessage = require('./MetaMessage'); var _MetaMessage2 = _interopRequireDefault(_MetaMessage);
var _RequestCard = require('./RequestCard'); var _RequestCard2 = _interopRequireDefault(_RequestCard);



/* An event row in the thread. A keyword line ("Keyword FORMS: …") with an
 * open request carries the request's card under it. */
const MetaMessageRow = ({ messageKey, text, sentAt }) => {
  const request = _hooks.useAppSelector.call(void 0, state => _requests.selectOpenRequestByMessageKey.call(void 0, state, messageKey))
  const line = _react2.default.createElement(_MetaMessage2.default, { messageKey: messageKey, text: text, sentAt: sentAt, __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}} )
  if (!request) return line
  return (
    _react2.default.createElement('div', { className: "meta-message--with-request", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      ,  line 
      , _react2.default.createElement(_RequestCard2.default, { request: request, __self: this, __source: {fileName: _jsxFileName, lineNumber: 19}} )
    )
  )
}

exports. default = MetaMessageRow
